import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { ReferenciaCabecera } from '../../../interfaces/ReferenciaCabecera';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import './headboardEspecial.scss';


const HeadboardEspecial = (props:ReferenciaCabecera) => {
   const { isBrowser, window } = useBrowserMode();

   return (
      <div className='o-headboard-especial' >
         {
            isBrowser && window.screen.width < 720 && props.imagenesArboles[1] ? 
               <img  className='o-headboard-especial__cover'
                  src={ props.imagenesArboles[1].file.url }
                  alt={ props.imagenesArboles[1] && props.imagenesArboles[1].title || "imagen cabecera" }
                  loading="lazy"
               />
            :
               <img  className='o-headboard-especial__cover'
                  src={ props.imagenesArboles[0].file.url }
                  alt={ props.imagenesArboles[0] && props.imagenesArboles[0].title || "imagen cabecera" }
                  loading="lazy"
               />
         }
            <div className='o-headboard-especial__info'>
               { props.tituloPrincipal &&
                  <h1 className='o-headboard-especial__info__title' >{ props.tituloPrincipal }</h1>
               }
               { props.descripcion &&
                  <p className='o-headboard-especial__info__text' >{ documentToReactComponents(props.descripcion.json) }</p>
               }
            </div>
      </div>
   )
}

export default HeadboardEspecial;
